export interface GuestI {
  id: string;
  eventId: string;
  userId: number;
  email: string;
  status: string;
  createdAt: number;
  updatedAt: number;
}

export interface EventI {
  id: number | string;
  calendarId: number | string;
  createdAt: number;
  description: string;
  endTime: number;
  startTime: number;
  title: string;
  updatedAt: number;
  userId: number | string;
  recurrenceRule?: string;
  icon?: string;
  utc: string;
  guests?: GuestI[];
}

export interface EditEventRequestI extends EventI {
  originalStart: number;
  editMode: 'this' | 'all' | 'following';
}

export interface RSVPResponseI {
  message: string;
  eventId: string;
  eventTitle: string;
  guestEmail: string;
  status: 'yes' | 'no' | 'maybe' | 'accepted' | 'declined';
}

export interface EventStateI {
  events: EventI[];
  event: EventI;
  eventTemplateInitialized: boolean;
  detailDate: string;
  loading: boolean;
  loadedRangeKey: string;
  rsvpResponse: RSVPResponseI;
}

export const state: EventStateI = {
  events: [],
  loading: false,
  detailDate: '',
  loadedRangeKey: '',
  eventTemplateInitialized: false,
  event: {
    id: 0,
    calendarId: 0,
    userId: 0,
    title: '',
    description: '',
    startTime: 0,
    endTime: 0,
    createdAt: 0,
    updatedAt: 0,
    recurrenceRule: '',
    icon: '',
    utc: '',
  },
  rsvpResponse: {
    message: '',
    eventId: '',
    eventTitle: '',
    guestEmail: '',
    status: 'yes',
  },
};
